import React, { useEffect, useContext, useState } from 'react'
import { makeStyles, Checkbox } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import SearchIcon from '@material-ui/icons/Search'
import OutsideClickHandler from 'react-outside-click-handler'
import { CheckedBox, UncheckedBox } from './Icons/index'
import { mappingTitleSearch } from '../ultils/dataUtil'

const useStyles = makeStyles({
  fbcContainer: {
    position: 'relative',
  },
  fbcHead: {
    height: 40,
    width: '100%',
    background: '#F4F5F7',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '9px 12px',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  fbcHeadRadio: {
    height: 40,
    width: '100%',
    background: '#F4F5F7',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '9px 12px',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  fbcBodyContent: {
    width: 320,
    background: '#FFFFFF',
    border: '1px solid #DFE4EB',
    boxShadow: '0px 2px 10px rgba(223, 228, 235, 0.5)',
    borderRadius: 3,
    padding: '16px 12px 16px 12px',
    boxSizing: 'border-box',
  },
  fbcBodyContentRadio: {
    width: '100%',
    background: '#FFFFFF',
    border: '1px solid #DFE4EB',
    boxShadow: '0px 2px 10px rgba(223, 228, 235, 0.5)',
    borderRadius: 3,
    padding: '12px 8px 12px 8px',
    boxSizing: 'border-box',
  },
  fbcBody: {
    position: 'absolute',
    right: 0,
    top: 44,
    zIndex: 2,
  },
  fbcHeadTitle: {
    fontSize: 14,
    lineHeight: '18px',
    fontWeight: 400,
    marginRight: 8,
    overflow: 'hidden',
    display: ' -webkit-box',
    lineClamp: 1,
    boxOrient: 'vertical',
    width: '100%',
  },
  fbcHeadCaret: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    height: '100%',
    transformOrigin: 'center',
    '& svg': {
      height: '100%',
    },
  },
  ExpandMoreIcon: {
    color: '#8C8C8C',
  },
  fbcSearchBox: {
    width: '100%',
    height: '40px',
    background: '#F4F5F7',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  fbcSearchIcon: {
    width: 28,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 12,
    '& svg': {
      width: 20,
    },
  },
  fbcSearchInput: {
    width: 'calc(100% - 28px)',
    height: '100%',
    background: 'transparent',
    outline: 'none',
    border: 'none',
    paddingLeft: 8,
    '&::placeholder': {
      fontSize: 14,
      lineHeight: 22,
      fontWeight: 400,
      color: '#757575',
    },
  },
  fbcCheckBlock: {
    borderBottom: '1px solid #DFE4EB',
    marginBottom: 20,
  },
  fbcCheckBlockTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    marginBottom: 12,
  },
  fbcCheckBlockList: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#DFE4EB',
      borderRadius: 3,
    },
    '& div:last-child': {
      paddingBottom: 0,
    },
  },
  fbcCheckBlockItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingBottom: 10,
    cursor: 'pointer',
  },
  fbcCheckBlockIcon: {
    marginRight: 6,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    top: '4px',
  },
  fbcCheckBlockValue: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  fbcHide: {
    display: 'none',
  },
  fbcRadioItem: {
    width: '100%',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '5px 12px',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '22px',
    overflow: 'hidden',
    '&:hover': {
      background: 'rgba(0,0,0,0.1)',
      borderRadius: 3,
    },
  },
  subInfoItem: {
    marginLeft: 4,
    fontWeight: 800,
    fontSize: 12,
  },
})

interface CheckBlockItemProps {
  data: any
  getValue: any
  itemInfo?: any
  index?: any
  isChecked?: any
  resetCheckBox?: any
}

const CheckBlockItem = ({
  data,
  getValue,
  itemInfo,
  index,
  isChecked,
  resetCheckBox,
}: CheckBlockItemProps) => {
  const classes = useStyles()
  const [toggle, setToggle] = useState(false)
  const onToggleCheckbox = () => {
    setToggle((prev: any) => {
      if (prev) {
        getValue({ ...data, isChecked: false })
        return false
      }
      getValue({ ...data, isChecked: true })
      return true
    })
  }

  useEffect(() => {
    resetCheckBox && setToggle(false)
  }, [resetCheckBox])

  useEffect(() => {
    setToggle(isChecked)
  }, [isChecked])
  return (
    <div onClick={onToggleCheckbox} className={classes.fbcCheckBlockItem}>
      <div className={classes.fbcCheckBlockIcon}>
        {toggle ? (
          <CheckedBox size={15} color="#1B3963" />
        ) : (
          <UncheckedBox size={15} color="" />
        )}
      </div>
      <div className={classes.fbcCheckBlockValue}>
        {mappingTitleSearch(data.value) || 'N/A'}
        {itemInfo !== undefined && (
          <>
            <div className={classes.subInfoItem}>
              [{itemInfo !== undefined ? `${itemInfo[index].value}` : ''}]
            </div>
          </>
        )}
      </div>
    </div>
  )
}

interface FilterBoxCommonProps {
  placeholder: any
  data: any
  setFilterValue: any
  isSearch: any
  isRadio: any
  customStyle?: any
  customStyleBody?: any
  itemInfo?: any
  isReset?: any
  selectedValue?: any
  selectedItems?: any
}

const SEPERATOR = ','
const FilterBoxCommon = ({
  placeholder,
  data,
  setFilterValue,
  isSearch,
  isRadio,
  customStyle,
  customStyleBody,
  itemInfo,
  isReset,
  selectedValue,
  selectedItems: selectedItemsProp,
}: FilterBoxCommonProps) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [selectedItems, setSelectedItems] = useState<any[]>([])
  const [internalData, setInternalData] = useState(data)
  const [inputValue, setInputValue] = useState('')
  const [radioHead, setRadioHead] = useState(() => {
    if (selectedValue !== undefined && selectedValue !== null) {
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        return selectedValue
      }
      if (selectedValue.value !== undefined) {
        return selectedValue.value
      }
    }
    return placeholder
  })
  const hasSelectedItemsProp = Array.isArray(selectedItemsProp)
  const currentSelectedItems = hasSelectedItemsProp
    ? selectedItemsProp
    : selectedItems

  useEffect(() => {
    if (isReset) {
      setRadioHead(placeholder)
      setSelectedItems([])
    }
  }, [isReset, placeholder])

  useEffect(() => {
    if (isRadio && selectedValue !== undefined) {
      if (selectedValue === null) {
        setRadioHead(placeholder)
        return
      }
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        setRadioHead(selectedValue)
        return
      }
      if (selectedValue?.value !== undefined) {
        setRadioHead(selectedValue.value)
      } else {
        setRadioHead(placeholder)
      }
    }
  }, [isRadio, placeholder, selectedValue])

  useEffect(() => {
    if (!isRadio && hasSelectedItemsProp) {
      setSelectedItems(selectedItemsProp)
    }
  }, [hasSelectedItemsProp, isRadio, selectedItemsProp])

  const onClickHead = () => {
    setOpen(!open)
  }

  const onChangeInput = (evt: any) => {
    setInputValue(evt.target.value)
    const clonedInternalData = JSON.parse(JSON.stringify(data))
    clonedInternalData.forEach((thisInternalData: any) => {
      thisInternalData.list = thisInternalData.list.filter(
        (item: any) =>
          item.value.toLowerCase().indexOf(evt.target.value.toLowerCase()) !==
          -1,
      )
    })
    setInternalData(clonedInternalData)
  }

  const onHandleGetCheckValue = (val: any) => {
    const cloned = JSON.parse(JSON.stringify(currentSelectedItems))
    if (val.isChecked) {
      if (
        cloned.filter((item: any) =>
          item.type
            ? item.value === val.value && item.type === val.type
            : item.value === val.value,
        ).length === 0
      ) {
        cloned.push({ ...val, value: val.value, id: val.id })
        if (!hasSelectedItemsProp) {
          setSelectedItems(cloned)
        }
        setFilterValue(cloned)
      }
    } else {
      const cloned = JSON.parse(JSON.stringify(currentSelectedItems))
      const updatedFilterItem = cloned.filter(
        (item: any) =>
          item.value !== val.value ||
          (item.type && item.value === val.value && item.type !== val.type),
      )
      if (!hasSelectedItemsProp) {
        setSelectedItems(updatedFilterItem)
      }
      setFilterValue(updatedFilterItem)
    }
  }

  const onHandleClickRadioItem = (item: any) => {
    setRadioHead(item.value)
    setOpen(false)
    setFilterValue(item)
  }

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setOpen(false)
      }}
    >
      {isRadio && (
        <>
          <div className={classes.fbcContainer} style={customStyle}>
            <div onClick={onClickHead} className={classes.fbcHeadRadio}>
              <div className={classes.fbcHeadTitle}>{radioHead}</div>
              <div
                className={classes.fbcHeadCaret}
                style={{ transform: `rotate(${open ? '180deg' : '0deg'})` }}
              >
                <ExpandMoreIcon className={classes.ExpandMoreIcon} />
              </div>
            </div>
            <div
              className={`${classes.fbcBody} ${open ? '' : classes.fbcHide}`}
              style={{ ...customStyle, ...customStyleBody }}
            >
              <div className={classes.fbcBodyContentRadio}>
                {itemInfo === undefined && (
                  <>
                    {data.map((item: any, index: any) => (
                      <div
                        key={index}
                        onClick={() => onHandleClickRadioItem(item)}
                        className={classes.fbcRadioItem}
                      >
                        {item.value}
                      </div>
                    ))}
                  </>
                )}
                {itemInfo !== undefined && (
                  <>
                    {data.map((item: any, index: any) => {
                      if (itemInfo[0][index].value !== 0) {
                        return (
                          <div
                            key={index}
                            onClick={() => onHandleClickRadioItem(item)}
                            className={classes.fbcRadioItem}
                          >
                            {item.value}

                            {itemInfo[0] !== undefined && (
                              <>
                                <div className={classes.subInfoItem}>
                                  [
                                  {itemInfo[0] !== undefined
                                    ? `${itemInfo[0][index].value}`
                                    : ''}
                                  ]
                                </div>
                              </>
                            )}
                          </div>
                        )
                      }
                      return <></>
                    })}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {!isRadio && (
        <>
          <div className={classes.fbcContainer} style={customStyle}>
            <div onClick={onClickHead} className={classes.fbcHead}>
              <div className={classes.fbcHeadTitle}>
                {currentSelectedItems.length === 0
                  ? radioHead
                  : currentSelectedItems
                      .map((item: any) => item.value || 'N/A')
                      .toString()}
              </div>
              <div
                className={classes.fbcHeadCaret}
                style={{ transform: `rotate(${open ? '180deg' : '0deg'})` }}
              >
                <ExpandMoreIcon className={classes.ExpandMoreIcon} />
              </div>
            </div>

            <div
              className={`${classes.fbcBody} ${open ? '' : classes.fbcHide}`}
              style={customStyleBody || {}}
            >
              <div
                className={classes.fbcBodyContent}
                style={customStyleBody || {}}
              >
                {isSearch && (
                  <div className={classes.fbcSearchBox}>
                    <div className={classes.fbcSearchIcon}>
                      <SearchIcon />
                    </div>
                    <input
                      className={classes.fbcSearchInput}
                      type="text"
                      placeholder="Search"
                      value={inputValue}
                      onChange={onChangeInput}
                    />
                  </div>
                )}

                {internalData.length === 1 && (
                  <>
                    {internalData[0].list.length === 0 && <div />}
                    {internalData[0].list.length !== 0 && (
                      <div
                        className={classes.fbcCheckBlock}
                        style={{ borderBottom: 'none', marginBottom: 0 }}
                      >
                        {internalData[0].title.length !== 0 && (
                          <div className={classes.fbcCheckBlockTitle}>
                            {internalData[0].title}
                          </div>
                        )}
                        <div
                          className={classes.fbcCheckBlockList}
                          style={{
                            maxHeight: internalData[0].heightScrollList,
                          }}
                        >
                          {itemInfo === undefined && (
                            <>
                              {internalData[0].list.map(
                                (item: any, index: any) => (
                                  <CheckBlockItem
                                    key={item.id}
                                    data={item}
                                    getValue={(val: any) =>
                                      onHandleGetCheckValue(val)
                                    }
                                    itemInfo={itemInfo[0]}
                                    index={index}
                                    isChecked={item.isChecked}
                                    resetCheckBox={isReset}
                                  />
                                ),
                              )}
                            </>
                          )}
                          {itemInfo !== undefined && (
                            <>
                              {internalData[0].list.map(
                                (item: any, index: any) => {
                                  if (itemInfo[0][index].value !== 0) {
                                    return (
                                      <CheckBlockItem
                                        key={item.id}
                                        data={item}
                                        getValue={(val: any) =>
                                          onHandleGetCheckValue(val)
                                        }
                                        itemInfo={itemInfo[0]}
                                        index={index}
                                        isChecked={item.isChecked}
                                        resetCheckBox={isReset}
                                      />
                                    )
                                  }
                                  return <></>
                                },
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}

                {internalData.length > 1 && (
                  <>
                    {internalData.map((item: any, indexOut: number) => (
                      <React.Fragment key={indexOut}>
                        {item.list.length === 0 && <div key={indexOut} />}
                        {item.list.length !== 0 && (
                          <>
                            <div
                              key={indexOut}
                              className={classes.fbcCheckBlock}
                              style={{
                                borderBottom:
                                  indexOut === internalData.length - 1
                                    ? 'unset'
                                    : '1px solid #DFE4EB',
                                marginBottom:
                                  indexOut === internalData.length - 1 ? 0 : 20,
                                paddingBottom:
                                  indexOut === internalData.length - 1 ? 0 : 20,
                              }}
                            >
                              {item.title.length !== 0 && (
                                <div className={classes.fbcCheckBlockTitle}>
                                  {item.title}
                                </div>
                              )}
                              <div
                                className={classes.fbcCheckBlockList}
                                style={{ maxHeight: item.heightScrollList }}
                              >
                                {itemInfo !== undefined && (
                                  <>
                                    {item.list.map((item: any, index: any) => {
                                      if (
                                        itemInfo[indexOut][index].value !== 0
                                      ) {
                                        return (
                                          <CheckBlockItem
                                            key={item.id}
                                            data={item}
                                            getValue={(val: any) =>
                                              onHandleGetCheckValue(val)
                                            }
                                            itemInfo={itemInfo[indexOut]}
                                            index={index}
                                            isChecked={item.isChecked}
                                            resetCheckBox={isReset}
                                          />
                                        )
                                      }
                                      return null
                                    })}
                                  </>
                                )}

                                {itemInfo === undefined && (
                                  <>
                                    {item.list.map((item: any, index: any) => (
                                      <CheckBlockItem
                                        key={item.id}
                                        data={item}
                                        getValue={(val: any) =>
                                          onHandleGetCheckValue(val)
                                        }
                                        itemInfo={itemInfo[indexOut]}
                                        index={index}
                                        isChecked={item.isChecked}
                                        resetCheckBox={isReset}
                                      />
                                    ))}
                                  </>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </React.Fragment>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </OutsideClickHandler>
  )
}

export default FilterBoxCommon
FilterBoxCommon.defaultProps = {
  customStyle: {},
}
